import CWJCLogo from '@/assets/branding/cwjc/CMJC_CWJC_Logo.png';

export default {
  name: 'All is Well',
  isSAML: true,
  allowPersonalCourses: false,
  logo: CWJCLogo,
  colors: {
    // Brand colors
    brand_primary: '#0259b1ff',
    brand_primary_hover: '#043260', // −10 L, −8 S
    brand_primary_highlight: '#0D86FF', // +23 L, +7 S
    brand_primary_mid: '#0060C0', // +8 L,  +2 S
    brand_primary_dark: '#000C17', // −25 L, −3 S (clamped)
    brand_secondary: '#052146', // hue +4°, −15 L, −13 S
  },
};
